// tslint:disable:react-a11y-anchors
import * as React from 'react';
import { Header } from '../Header/Header';
import { Container } from '../Layout/Container';
import { Section } from '../Section/Section';

interface IErrorPageProps {
  /**
   * resource bundle for texts/links in the error page. Should have the following keys:
   *
   * - errorHeader
   * - errorTitle
   * - errorDescription
   * - errorBackText
   * - errorContactLink
   * - errorContactText
   */
  resources: {
    errorHeader: string;
    errorTitle: string;
    errorDescription: string;
    errorBackText: string;
    errorContactLink: string;
    errorContactText: string;
  };
}

/**
 * ErrorPage is a common component in most Hybrid App when there is a fatal error that the App could not recover easily.
 * All the keys of resources are required; please provide a default value for them instead of relying on resource bundle because ajax to get resource bundle may fail
 */
export const ErrorPage: React.FC<IErrorPageProps> = ({ resources }) => {
  return (
    <div>
      <Header>{resources.errorHeader}</Header>
      <Section>
        <Container>
          <strong>{resources.errorTitle}</strong>
          <p>{resources.errorDescription}</p>
          <br />
          <br />
          <a className="btn btn-primary btn-wider" href=".">
            {resources.errorBackText}
          </a>
          &nbsp; &nbsp;
          <a href={resources.errorContactLink} className="btn btn-default btn-wider">
            {resources.errorContactText}
          </a>
        </Container>
      </Section>
    </div>
  );
};

export default ErrorPage;
